import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { slideDownUp } from '../../shared/animations';
import { ApiService } from '../../helpers/api.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
  animations: [slideDownUp],
})
export class SidebarComponent {
  isExpanded: boolean = true;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  routeMenu: any[] = [];
  private broadcast = new BroadcastChannel('session_channel');


  constructor(
    public router: Router,
    private sidebarService: ApiService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private location: Location,
  ) {
    // var userExist = SecurityProvider.getUserDecoded();
    // if(userExist == ""){
    //   this.router.navigate(['auth/login']).then(() => {
    //     this.location.replaceState('auth/login');
    //   });
    //   return;
    // }
    this.initStore();
  }

  async initStore() {
    
  }

  

  handleSidebarToggle = () => this.isExpanded = !this.isExpanded;


  // $('.js-menu-toggle').click(function(e) {

  // 	var $this = $(this);

  	

  // 	if ( $('body').hasClass('show-sidebar') ) {
  // 		$('body').removeClass('show-sidebar');
  // 		$this.removeClass('active');
  // 	} else {
  // 		$('body').addClass('show-sidebar');	
  // 		$this.addClass('active');
  // 	}

  // 	e.preventDefault();

  // });

  // // click outisde offcanvas
	// $(document).mouseup(function(e) {
  //   var container = $(".sidebar");
  //   if (!container.is(e.target) && container.has(e.target).length === 0) {
  //     if ( $('body').hasClass('show-sidebar') ) {
	// 			$('body').removeClass('show-sidebar');
	// 			$('body').find('.js-menu-toggle').removeClass('active');
	// 		}
  //   }
	// }); 


  ngOnInit() {
    
    // this.broadcast.onmessage = (event) => {
    //   if(event.data.type === 'SESSION_FAIL') {
    //     // !this.router.url.includes("login")
    //     this.router.navigate(['auth/login']).then(() => {
    //       this.location.replaceState('auth/login');
    //     });
    //     return;
    //   }
    // };
    

    /*

            value.body.menu.forEach(element => {
            
              let submenu: Children[] = [];
    
              for (let index = 0; index < element.submenu.length; index++) {
                const sub = element.submenu[index];
                submenu.push({
                  active_route: "",
                  children: [],
                  exact: true,
                  hasFather: false,
                  id: sub.idsubmenu,
                  islink: sub.idsubmenu,
                  route: sub.url,
                  slug: "",
                  title: sub.descripcion
                });
              }
              
              this.routeMenu.push({
                active_route: "",
                children: submenu,
                exact: false,
                hasFather: submenu.length > 0 ? true : false,
                id: element.idmenu,
                islink: element.idmenu,
                route: element.url,
                slug: "toggle-menu-"+element.idmenu,
                title: element.descripcion
              });
            });
    */
  }

  
  // setActiveDropdown() {
  //   const selector = document.querySelector('ul a[routerLink="' + window.location.hash.split("/").reverse().at(0) + '"]');
    
  //   if (selector) {
  //     selector.classList.add('active');
  //     const ul: any = selector.closest('ul.sub-menu');
  //     if (ul) {
  //       let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
  //       if (ele.length) {
  //         ele = ele[0];
  //         setTimeout(() => {
  //           ele.click();
  //         });
  //       }
  //     }
  //   }
  // }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getIconMenu = (idMenu: any) :string => {
    // 
    var itemsMenuIcons = [
      'edit',
      'users-group',
      'bar-chart',
      'settings',
      'edit',
      'edit',
      'edit',
    ];
    return itemsMenuIcons[idMenu];
  }

  
  goToSearchPage() {
    this.router.navigate(["admin/search"]);
  }

  logout() {
    this.broadcast.postMessage({ type: 'SESSION_EXPIRED' });
    this.router.navigate(['admin/ofpagesession']);
  }

  



  getVersion(): string {
    return environment.version;
  }
}
